export const CAPCITO_TERMS = 'https://www.capcito.com/sv/about/terms-of-use'
export const AVTAL24 = 'https://avtal24.se/mr-shoebox'
export const DEFISO_PORTAL = 'https://www.defiso.se/mr-shoebox/'
